import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';

import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Table, Tag, Space, Button, Spin } from 'antd';
import { getDirecteurs } from './directeur.reducer';
import { IDirecteur } from 'app/shared/model/directeur.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT, AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEcole } from '../ecole/ecole.reducer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';

export const Directeur = (props: RouteComponentProps<{ ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const loading = useAppSelector(state => state.directeur.loading);
  const directeurList = useAppSelector(state => state.directeur.entities);
  const isDirecteur = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.DIRECTEUR]));

  useEffect(() => {
    dispatch(getDirecteurs(props.match.params.ecoleid));
    dispatch(getEcole(props.match.params.ecoleid));
  }, []);

  const columns = [
    {
      title: 'Prénom',
      dataIndex: 'prenom',
      key: 'prenom',
    },
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
    },
    {
      title: 'E-mail',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      render: role => <Tag color="gray">{role}</Tag>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: status => (status ? <Tag color="green">Activé</Tag> : <Tag color="red">Désactivé</Tag>),
    },
    {
      title: 'Option',
      dataIndex: 'id',
      key: 'id',
      render: id => (
        <Space size="middle">
          <Button type="primary" style={{ height: 30, width: 45 }}>
            <Link to={`/directeur/${currentEcole && currentEcole.id}/${id}/details`}>
              <FontAwesomeIcon icon="eye" />{' '}
            </Link>
          </Button>
        </Space>
      ),
    },
  ];

  const data = directeurList.map((directeur, i) => ({
    id: directeur.id,
    nom: directeur.lastName,
    prenom: directeur.firstName,
    email: directeur.email,
    status: directeur.activated,
    role: directeur.authorities.map(d => d),
  }));

  const { match } = props;

  return (
    <div>
      <h2 id="directeur-heading" data-cy="DirecteurHeading">
        <Translate contentKey="korischoolApp.directeur.home.title">Directeurs</Translate>
        <div style={{ textAlign: 'right' }}>
          <Link
            to={`/directeur/${currentEcole && currentEcole.id}/new`}
            className="btn jh-create-entity"
            style={{ backgroundColor: '#F28E19', color: 'white' }}
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="korischoolApp.directeur.home.createLabel">Create new Directeur</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        <Spin spinning={loading} tip="Chargement...">
          <Table columns={columns} dataSource={data} />
        </Spin>
      </div>
    </div>
  );
};

export default Directeur;
